// extracted by mini-css-extract-plugin
module.exports = {"empty":"jut__Icon__empty","svgIcon":"jut__Icon__svgIcon","iconSize1":"jut__Icon__iconSize1","iconSize2":"jut__Icon__iconSize2","iconSize3":"jut__Icon__iconSize3"};